import { BaseApiUrl } from '../../../configVariables';
import { TableContinuationToken } from '../../../model';
import apiClient from '../../../utils/apiClient';

export default interface IAllowedCrewMember {
    rowKey: string;
    timestamp: string;
    isActive: boolean;
}

export interface AllowedCrewMember {
    items: IAllowedCrewMember[];
    nextPageToken: TableContinuationToken | null;
}

interface AddStaffNumbersRequest {
    staffNumbers: string[];
}

export interface AddStaffNumbersResponse {
    successCount: number;
    duplicateCount: number;
    duplicates: string[];
    failureCount: number;
    failures: Array<{ staffNumber: string; reason: string }>;
}

export const fetchAllowedCrewMembers = async (): Promise<AllowedCrewMember> => {
    const url = `${BaseApiUrl}/appsettings/allowedCrewMembers`;
    const result = await apiClient.get<AllowedCrewMember>(url);

    if (Array.isArray(result.data)) {
        const items: IAllowedCrewMember[] = result.data.map((item) => {
            return item as IAllowedCrewMember;
        });
        return { items, nextPageToken: null };
    }

    return result.data as AllowedCrewMember;
};

export const addAllowedCrewMembers = async (
    staffNumbers: string[]
): Promise<AddStaffNumbersResponse> => {
    const response = await apiClient.post<AddStaffNumbersResponse, AddStaffNumbersRequest>(
        `${BaseApiUrl}/appsettings/allowedCrewMembers/add`,
        { staffNumbers }
    );
    return response.data;
};

export const deleteAllowedCrewMember = async (staffNumber: string): Promise<void> => {
    await apiClient.delete(`${BaseApiUrl}/appsettings/allowedCrewMembers/${encodeURIComponent(staffNumber)}`);
};